module.exports = __webpack_public_path__ + "img/rectangulo-l.80b3a40c.svg";